import { Typography, useMediaQuery } from "@mui/material";
import classes from "../../../styles/pujaStep.module.css";
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator, timelineItemClasses } from "@mui/lab";
import BookPujaIcon from "../../../../../public/assets/newEvent/abTesting/selectPujaIcon.svg";
import DonateIcon from "../../../../../public/assets/newEvent/abTesting/donate.svg";
import GiftIcon from "../../../../../public/assets/newEvent/abTesting/gift.svg";
import NotesIcon from "../../../../../public/assets/newEvent/abTesting/notes.svg";
import WatchIcon from "../../../../../public/assets/newEvent/abTesting/watch.svg";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { EventDataContext } from "@components/context/EventDataContext";
import { useRouter } from "next/router";
import { LANGUAGE } from "@utils/constants";
function PujaStep() {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const bigScreen = useMediaQuery("(min-width:768px)");
  const {
    data
  } = useContext(EventDataContext); // Event data
  const [deliveryText, setDeliveryText] = useState("");
  const [steps, setSteps] = useState([]);
  useEffect(() => {
    if (router.locale === LANGUAGE.ENGLISH) {
      setDeliveryText(`Authentic prasad from the temple will be delivered within ${data?.deliveryStartDay ?? 7} - ${data?.deliveryEndDay ?? 10} days`);
    } else {
      setDeliveryText(`मंदिर से शुद्ध प्रसाद ${data?.deliveryStartDay ?? 7} - ${data?.deliveryEndDay ?? 10} दिनों के भीतर वितरित किया जाएगा।`);
    }
    if (data?.isPrasad) {
      setSteps([{
        id: 1,
        step: t("select-puja"),
        description: t("select-puja-and-bhet-daan-like-vastra-daan-gau-seva-brahman-bhojan-etc"),
        connector: true
      }, {
        id: 2,
        step: t("pay-dakshina-0"),
        description: t("securely-pay-your-dakshina-using-upi-card-or-net-banking"),
        connector: true
      }, {
        id: 3,
        step: t("fill-sankalp-form"),
        description: t("enter-offering-name-s-gotra-prasad-delivery-address-and-puja-wish"),
        connector: true
      }, {
        id: 4,
        step: t("on-puja-date-watch-puja-video"),
        description: t("short-darshan-video-will-be-shared-on-puja-tithi-full-video-with-name-gotra-will-be-sent-on-whatsapp-within-2-3-days"),
        connector: true
      }, {
        id: 5,
        step: t("prasad-delivered-at-home"),
        description: deliveryText
      }]);
    } else {
      setSteps([{
        id: 1,
        step: t("select-puja"),
        description: t("select-puja-and-bhet-daan-like-vastra-daan-gau-seva-brahman-bhojan-etc"),
        connector: true
      }, {
        id: 2,
        step: t("pay-dakshina-0"),
        description: t("securely-pay-your-dakshina-using-upi-card-or-net-banking"),
        connector: true
      }, {
        id: 3,
        step: t("fill-sankalp-form"),
        description: t("enter-offering-name-s-gotra-prasad-delivery-address-and-puja-wish"),
        connector: true
      }, {
        id: 4,
        step: t("on-puja-date-watch-puja-video"),
        description: t("short-darshan-video-will-be-shared-on-puja-tithi-full-video-with-name-gotra-will-be-sent-on-whatsapp-within-2-3-days")
      }]);
    }
  }, [data.deliveryEndDay, data.deliveryStartDay, data.isPrasad, deliveryText, router.locale, t]);
  return <>
      {!bigScreen ? <div>
          <div className={classes.headerContainer}>
            <Typography className={classes.heading}>
              {t("how-to")}
              <span> {t("participate-in-puja")}</span>?
            </Typography>
            <Typography className={classes.subHeading}>
              {t("3-easy-steps-to-offer-puja-with-utsav")}{" "}
            </Typography>
          </div>

          <Timeline sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0
        },
        [`& .${timelineItemClasses.root}`]: {
          padding: 0,
          margin: 0
        },
        ["&.MuiTimeline-root"]: {
          padding: "6px 0px 0px 0px",
          margin: "5px 0 0 0"
        },
        ["& .MuiTimelineConnector-root"]: {
          borderStyle: "dotted",
          borderColor: "#f5a623",
          borderWidth: "1px"
        }
      }}>
            {steps.map((item, idx) => <TimelineItem key={idx}>
                <TimelineSeparator>
                  <TimelineDot sx={{
              background: "linear-gradient(to right, #ff9800, #ff5757)",
              height: "50px",
              width: "50px",
              borderRadius: "15px",
              border: "unset",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px"
            }}>
                    {idx == 0 && <BookPujaIcon />}
                    {idx == 1 && <DonateIcon />}
                    {idx == 2 && <NotesIcon />}
                    {idx == 3 && <WatchIcon />}
                    {idx == 4 && data.isPrasad && <GiftIcon />}
                  </TimelineDot>
                  {item.connector && <TimelineConnector sx={{
              backgroundColor: "#f5a623"
              // borderStyle: "dotted",
            }} />}
                </TimelineSeparator>

                <TimelineContent sx={{
            p: "6px 16px 12px 16px"
          }}>
                  <Typography component="span" className={classes.itemHeading}>
                    {item.step}
                  </Typography>
                  <Typography className={classes.itemDescription}>
                    {item.description}
                  </Typography>
                </TimelineContent>
              </TimelineItem>)}
          </Timeline>
        </div> : <div>
          <div className={classes.headerContainer}>
            <Typography className={classes.heading}>
              {t("how-to")}
              <span> {t("participate-in-puja")}</span>?
            </Typography>
            <Typography className={classes.subHeading}>
              {t("3-easy-steps-to-offer-puja-with-utsav")}{" "}
            </Typography>
            <div className={classes.kriyaLine}></div>
          </div>

          <div className={classes.stepsContainer}>
            {steps.map((item, idx) => <div key={idx} className={classes.stepItem}>
                <div className={classes.stepIcon}>
                  {idx == 0 &&
            // <Image
            //   src={BookPujaImage}
            //   width={30}
            //   height={30}
            //   alt="Book Puja"
            // />
            <BookPujaIcon />}
                  {idx == 1 &&
            // <Image
            //   src={DonateImage}
            //   width={30}
            //   height={30}
            //   alt="Book Puja"
            // />
            <DonateIcon />}
                  {idx == 2 &&
            // <Image
            //   src={NotesImage}
            //   width={30}
            //   height={30}
            //   alt="Book Puja"
            // />
            <NotesIcon />}
                  {idx == 3 &&
            // <Image
            //   src={WatchImage}
            //   width={30}
            //   height={30}
            //   alt="Book Puja"
            // />
            <WatchIcon />}
                  {idx == 4 &&
            // <Image
            //   src={GiftImage}
            //   width={30}
            //   height={30}
            //   alt="Book Puja"
            // />
            <GiftIcon />}
                </div>
                <div className={classes.stepContent}>
                  <Typography className={classes.itemHeading}>
                    {item.step}
                  </Typography>
                  <Typography className={classes.itemDescription}>
                    {item.description}
                  </Typography>
                </div>
              </div>)}
          </div>
        </div>}
    </>;
}
export default PujaStep;